module.exports = __webpack_public_path__ + "static/i-am-that-a6f12c6dc25f1510a9a3cf329dde989a.jpg";